import { AccessMenuItem } from "../interfaces/users/access.interface";

export const BRF_MENU_ITEMS = [
  {
    icon: 'dashboard',
    title: 'SIDEBAR.DASHBOARD',
    name: 'dashboard',
    route: '/panel/dashboard'
  },

  {
    icon: 'label',
    title: 'SIDEBAR.LABELS.TITLE',
    name: 'labelsGroup',
    route: '/panel/labels',
    parentPermission: 'labels',
    subItems: [
      {
        title: 'SIDEBAR.LABELS.MONITOR',
        name: 'labels',
        route: '/panel/labels'
      },
      {
        title: 'SIDEBAR.LABELS.PRINTED',
        name: 'labelsPrinted',
        route: '/panel/labels/printed'
      },
    ]
  },

  {
    icon: 'integration_instructions',
    title: 'SIDEBAR.BRF.TITLE',
    name: 'brfIntegrationMonitor',
    route: '/panel/brf',
    subItems: [
      {
        title: 'SIDEBAR.BRF.PERSON',
        name: 'brfPerson',
        route: '/panel/brf/person'
      },
      {
        title: 'SIDEBAR.BRF.PRODUCT',
        name: 'brfProduct',
        route: '/panel/brf/product'
      },
      {
        title: 'SIDEBAR.BRF.PRICE',
        name: 'brfPrice',
        route: '/panel/brf/price'
      },
      {
        title: 'SIDEBAR.BRF.SALE',
        name: 'brfSale',
        route: '/panel/brf/sale'
      },
    ]
  },

  {
    icon: 'id_card',
    title: 'SIDEBAR.MY_DATA',
    name: 'myData',
    route: '/panel/my-data'
  },

  {
    icon: 'groups',
    title: 'SIDEBAR.PEOPLE',
    name: 'persons',
    route: '/panel/person'
  },

  {
    icon: 'point_of_sale',
    title: 'SIDEBAR.PDV.TITLE',
    name: 'pdv',
    route: '/panel/pdv',
    parentPermission: 'pdv',
    subItems: [
      {
        title: 'SIDEBAR.PDV.REGISTRATION',
        name: 'pdv',
        route: '/panel/pdv'
      },
      {
        title: 'SIDEBAR.PDV.SYNC_HISTORY',
        name: 'pdvSyncHistory',
        route: '/panel/pdv/sync-history'
      },
    ]
  },

  {
    icon: 'layers',
    title: 'SIDEBAR.PRODUCTS.TITLE',
    name: 'productGroups',
    route: '/panel/products',
    parentPermission: 'products',
    subItems: [
      {
        title: 'SIDEBAR.PRODUCTS.GROUPING_SIMILAR_ITEMS',
        name: 'similarProducts',
        route: '/panel/products/grouping-similar-items'
      },
      {
        title: 'SIDEBAR.PRODUCTS.BRAND',
        name: 'brand',
        route: '/panel/products/brands'
      },
      {
        title: 'SIDEBAR.PRODUCTS.GROUPS_AND_SUBGROUPS',
        name: 'groupAndSubGroup',
        route: '/panel/products/groups-and-subgroups'
      },
      {
        title: 'SIDEBAR.PRODUCTS.PRODUCTION_LAUNCH',
        name: 'productionLaunch',
        route: '/panel/products/production-launch'
      },
      {
        title: 'SIDEBAR.PRODUCTS.COMPOSITE_PRODUCTS',
        name: 'compositeProduct',
        route: '/panel/products/composite-products'
      },
      {
        title: 'SIDEBAR.PRODUCTS.PROMOTIONS',
        name: 'promotions',
        route: '/panel/products/promotions'
      },
      {
        title: 'SIDEBAR.PRODUCTS.TITLE',
        name: 'products',
        route: '/panel/products'
      },
      {
        title: 'SIDEBAR.PRODUCTS.TYPE',
        name: 'type',
        route: '/panel/products/types'
      },
      {
        title: 'SIDEBAR.PRODUCTS.UNITS_OF_MEASURE',
        name: 'unitOfMeasure',
        route: '/panel/products/units-of-measurement'
      }
    ]
  },

  {
    icon: 'insert_drive_file',
    title: 'SIDEBAR.REPORT.TITLE',
    name: 'reportGroup',
    route: '/panel/report',
    subItems: [
      {
        title: 'SIDEBAR.REPORT.PRODUCT_RANKING',
        name: 'productRanking',
        route: '/panel/report/product-ranking'
      },
      {
        title: 'SIDEBAR.REPORT.BILLING_SUMMARY',
        name: 'billingSummary',
        route: '/panel/report/billing-summary'
      },
      {
        title: 'SIDEBAR.REPORT.TAX_SUMMARY',
        name: 'taxSummary',
        route: '/panel/report/tax-summary'
      },
      {
        title: 'SIDEBAR.REPORT.PAYMENT_METHODS',
        name: 'paymentMethods',
        route: '/panel/report/payment-methods'
      },
    ]
  },

  {
    icon: 'supervisor_account',
    title: 'SIDEBAR.USERS.TITLE',
    name: 'usersGroup',
    route: '/panel/users',
    parentPermission: 'user',
    subItems: [
      {
        title: 'SIDEBAR.USERS.TITLE',
        name: 'user',
        route: '/panel/users'
      },
      {
        title: 'SIDEBAR.USERS.ACCESS_PROFILES',
        name: 'accessProfiles',
        route: '/panel/users/access-profiles'
      }
    ]
  },
];

export const PANEL_MENU_ITEMS = [
  {
    icon: 'dashboard',
    title: 'SIDEBAR.DASHBOARD',
    name: 'dashboard',
    route: '/panel/dashboard'
  },
  {
    icon: 'currency_exchange',
    title: 'SIDEBAR.PRICE_ADJUSTMENT.TITLE',
    name: 'priceAdjustment',
    route: '/panel/price-adjustment',
    subItems: [
      {
        title: 'SIDEBAR.PRICE_ADJUSTMENT.MANUAL_ADJUSTMENT',
        name: 'manualAdjustment',
        route: '/panel/price-adjustment/manual-adjustment'
      },
      {
        title: 'SIDEBAR.PRICE_ADJUSTMENT.PENDING',
        name: 'pending',
        route: '/panel/price-adjustment/pending'
      },
      {
        title: 'SIDEBAR.PRICE_ADJUSTMENT.COST_VARIANCE',
        name: 'costVariance',
        route: '/panel/price-adjustment/cost-variance'
      },
    ]
  },

  {
    icon: 'balance',
    title: 'SIDEBAR.BALANCE.TITLE',
    name: 'balanceGroups',
    route: '/panel/balance',
    parentPermission: 'balance',
    subItems: [
      {
        title: 'SIDEBAR.BALANCE.TITLE',
        name: 'balance',
        route: '/panel/balance'
      },
      {
        title: 'SIDEBAR.BALANCE.BALANCE_SHEET',
        name: 'balance-sheet',
        route: '/panel/balance/balance-sheet'
      },
    ]
  },

  {
    icon: 'settings_applications',
    title: 'SIDEBAR.TAX_SETTINGS',
    name: 'taxSettings',
    route: '/panel/tax-settings'
  },

  {
    icon: 'label',
    title: 'SIDEBAR.LABELS.TITLE',
    name: 'labelsGroup',
    route: '/panel/labels',
    parentPermission: 'labels',
    subItems: [
      {
        title: 'SIDEBAR.LABELS.MONITOR',
        name: 'labels',
        route: '/panel/labels'
      },
      {
        title: 'SIDEBAR.LABELS.PRINTED',
        name: 'labelsPrinted',
        route: '/panel/labels/printed'
      },
    ]
  },

  {
    icon: 'attach_money',
    title: 'SIDEBAR.FINANCIAL.TITLE',
    name: 'finance',
    route: '/panel/financial',
    subItems: [
      {
        title: 'SIDEBAR.FINANCIAL.CARD_OPERATORS',
        name: 'acquirersAndBrands',
        route: '/panel/financial/card-operators'
      },
      {
        title: 'SIDEBAR.FINANCIAL.CARD_BRANDS',
        name: 'cardBrand',
        route: '/panel/financial/card-brands'
      },
      {
        title: 'SIDEBAR.FINANCIAL.BANKS',
        name: 'bank',
        route: '/panel/financial/banks'
      },
      {
        title: 'SIDEBAR.PRODUCTS.COST_CENTER',
        name: 'costCenter',
        route: '/panel/financial/cost-center'
      },
      {
        title: 'SIDEBAR.FINANCIAL.ACCOUNTS',
        name: 'account',
        route: '/panel/financial/accounts'
      },
      {
        title: 'SIDEBAR.AGREEMENTS.TITLE',
        name: 'agreement',
        route: '/panel/agreements',
      },
      {
        title: 'SIDEBAR.FINANCIAL.PAYMENT_METHODS',
        name: 'paymentMethod',
        route: '/panel/financial/payment-methods'
      },
      {
        title: 'SIDEBAR.FINANCIAL_MONITOR.TITLE',
        name: 'financialMonitor',
        route: '/panel/financial/financial-monitor'
      },
      {
        title: 'SIDEBAR.FINANCIAL.ACCOUNT_MOVEMENT_TYPES',
        name: 'accountMovementType',
        route: '/panel/financial/account-movement-types'
      },
      {
        title: 'SIDEBAR.FINANCIAL.CHANGE_TYPES',
        name: 'changeType',
        route: '/panel/financial/change-types'
      }
    ]
  },

  {
    icon: 'integration_instructions',
    title: 'SIDEBAR.BRF.TITLE',
    name: 'brfIntegrationMonitor',
    route: '/panel/brf',
    subItems: [
      {
        title: 'SIDEBAR.BRF.PERSON',
        name: 'brfPerson',
        route: '/panel/brf/person'
      },
      {
        title: 'SIDEBAR.BRF.PRODUCT',
        name: 'brfProduct',
        route: '/panel/brf/product'
      },
      {
        title: 'SIDEBAR.BRF.PRICE',
        name: 'brfPrice',
        route: '/panel/brf/price'
      },
      {
        title: 'SIDEBAR.BRF.SALE',
        name: 'brfSale',
        route: '/panel/brf/sale'
      },
    ]
  },

  {
    icon: 'id_card',
    title: 'SIDEBAR.MY_DATA',
    name: 'myData',
    route: '/panel/my-data'
  },

  {
    icon: 'monitoring',
    title: 'SIDEBAR.TAX_MONITORING.TITLE',
    name: 'salesInvoice',
    route: '/panel/tax-monitoring/inbound',
    parentPermission: 'salesInvoice',
    subItems: [
      {
        title: 'SIDEBAR.TAX_MONITORING.INBOUND_DOCUMENT_MONITOR',
        name: 'inbound',
        route: '/panel/tax-monitoring/inbound'
      },
      {
        title: 'SIDEBAR.TAX_MONITORING.OUTBOUND_DOCUMENT_MONITOR',
        name: 'outbound',
        route: '/panel/tax-monitoring/outbound'
      },
    ]
  },

  {
    icon: 'groups',
    title: 'SIDEBAR.PEOPLE',
    name: 'persons',
    route: '/panel/person'
  },

  {
    icon: 'point_of_sale',
    title: 'SIDEBAR.PDV.TITLE',
    name: 'pdv',
    route: '/panel/pdv',
    parentPermission: 'pdv',
    subItems: [
      {
        title: 'SIDEBAR.PDV.REGISTRATION',
        name: 'pdv',
        route: '/panel/pdv'
      },
      {
        title: 'SIDEBAR.PDV.SYNC_HISTORY',
        name: 'pdvSyncHistory',
        route: '/panel/pdv/sync-history'
      },
    ]
  },

  {
    icon: 'layers',
    title: 'SIDEBAR.PRODUCTS.TITLE',
    name: 'productGroups',
    route: '/panel/products',
    parentPermission: 'products',
    subItems: [
      {
        title: 'SIDEBAR.PRODUCTS.GROUPING_SIMILAR_ITEMS',
        name: 'similarProducts',
        route: '/panel/products/grouping-similar-items'
      },
      {
        title: 'SIDEBAR.PRODUCTS.BRAND',
        name: 'brand',
        route: '/panel/products/brands'
      },
      {
        title: 'SIDEBAR.PRODUCTS.GROUPS_AND_SUBGROUPS',
        name: 'groupAndSubGroup',
        route: '/panel/products/groups-and-subgroups'
      },
      {
        title: 'SIDEBAR.PRODUCTS.PRODUCTION_LAUNCH',
        name: 'productionLaunch',
        route: '/panel/products/production-launch'
      },
      {
        title: 'SIDEBAR.PRODUCTS.COMPOSITE_PRODUCTS',
        name: 'compositeProduct',
        route: '/panel/products/composite-products'
      },
      {
        title: 'SIDEBAR.PRODUCTS.PROMOTIONS',
        name: 'promotions',
        route: '/panel/products/promotions'
      },
      {
        title: 'SIDEBAR.PRODUCTS.TITLE',
        name: 'products',
        route: '/panel/products'
      },
      {
        title: 'SIDEBAR.PRODUCTS.TYPE',
        name: 'type',
        route: '/panel/products/types'
      },
      {
        title: 'SIDEBAR.PRODUCTS.UNITS_OF_MEASURE',
        name: 'unitOfMeasure',
        route: '/panel/products/units-of-measurement'
      }
    ]
  },

  {
    icon: 'gavel',
    title: 'SIDEBAR.TAX_RULES.TITLE',
    route: '/panel/tax-rules',
    name: 'taxRuleGroup',
    subItems: [
      {
        title: 'SIDEBAR.TAX_RULES.CEST',
        name: 'cest',
        route: '/panel/tax-rules/cest'
      },
      {
        title: 'SIDEBAR.TAX_RULES.CFOP',
        name: 'cfop',
        route: '/panel/tax-rules/cfop'
      },
      {
        title: 'SIDEBAR.TAX_RULES.CSOSN',
        name: 'csosn',
        route: '/panel/tax-rules/csosn'
      },
      {
        title: 'SIDEBAR.TAX_RULES.CST_ICMS',
        name: 'cstIcms',
        route: '/panel/tax-rules/cst-icms'
      },
      {
        title: 'SIDEBAR.TAX_RULES.CST_IPI',
        name: 'cstIpi',
        route: '/panel/tax-rules/cst-ipi'
      },
      {
        title: 'SIDEBAR.TAX_RULES.CST_PIS_COFINS',
        name: 'cstPisCofins',
        route: '/panel/tax-rules/cst-pis-cofins'
      },
      {
        title: 'SIDEBAR.TAX_RULES.NCM',
        name: 'ncm',
        route: '/panel/tax-rules/ncm'
      },
      {
        title: 'SIDEBAR.TAX_RULES.REDUCTIONS_ICMS_TAX',
        name: 'reductionsIcmsTax',
        route: '/panel/tax-rules/reductions-icms-tax'
      },
      {
        title: 'SIDEBAR.TAX_RULES.DIFAL_TAX_RULES',
        name: 'difalTaxRules',
        route: '/panel/tax-rules/difal-tax-rules'
      },
      {
        title: 'SIDEBAR.TAX_RULES.FCP_TAX_RULES',
        name: 'fcpTaxRules',
        route: '/panel/tax-rules/fcp-tax-rules'
      },
      {
        title: 'SIDEBAR.TAX_RULES.ICMS_TAX_RULES',
        name: 'icmsTaxRules',
        route: '/panel/tax-rules/icms-tax-rules'
      },
      {
        title: 'SIDEBAR.TAX_RULES.IPI_TAX_RULES',
        name: 'ipiTaxRules',
        route: '/panel/tax-rules/ipi-tax-rules'
      },
      {
        title: 'SIDEBAR.TAX_RULES.PIS_COFINS_TAX_RULES',
        name: 'pisCofinsTaxRules',
        route: '/panel/tax-rules/pis-cofins-tax-rules'
      },
      {
        title: 'SIDEBAR.TAX_RULES.ST_TAX_RULES',
        name: 'stTaxRules',
        route: '/panel/tax-rules/st-tax-rules'
      }
    ]
  },

  {
    icon: 'insert_drive_file',
    title: 'SIDEBAR.REPORT.TITLE',
    name: 'reportGroup',
    route: '/panel/report',
    subItems: [
      {
        title: 'SIDEBAR.REPORT.PRODUCT_RANKING',
        name: 'productRanking',
        route: '/panel/report/product-ranking'
      },
      {
        title: 'SIDEBAR.REPORT.BILLING_SUMMARY',
        name: 'billingSummary',
        route: '/panel/report/billing-summary'
      },
      {
        title: 'SIDEBAR.REPORT.TAX_SUMMARY',
        name: 'taxSummary',
        route: '/panel/report/tax-summary'
      },
      {
        title: 'SIDEBAR.REPORT.PAYMENT_METHODS',
        name: 'paymentMethods',
        route: '/panel/report/payment-methods'
      },
    ]
  },

  {
    icon: 'supervisor_account',
    title: 'SIDEBAR.USERS.TITLE',
    name: 'usersGroup',
    route: '/panel/users',
    parentPermission: 'user',
    subItems: [
      {
        title: 'SIDEBAR.USERS.TITLE',
        name: 'user',
        route: '/panel/users'
      },
      {
        title: 'SIDEBAR.USERS.ACCESS_PROFILES',
        name: 'accessProfiles',
        route: '/panel/users/access-profiles'
      }
    ]
  },
];

export const MOCKED_MENU_TOP_ITEMS: AccessMenuItem[] = [
  {
    icon: 'home',
    title: 'SIDEBAR.HOME',
    name: 'home',
    route: '/panel/home'
  },
];

export const MOCKED_MENU_BOTTOM_ITEMS: AccessMenuItem[] = [
  {
    icon: 'logout',
    title: 'SIDEBAR.LOGOUT',
    name: 'logout',
    route: '/login'
  },
];

export const MY_DATA_MENU_ITEMS: AccessMenuItem[] = [
  ...MOCKED_MENU_TOP_ITEMS,
  {
    icon: 'id_card',
    title: 'SIDEBAR.MY_DATA',
    name: 'my-data',
    route: '/panel/my-data'
  },
  ...MOCKED_MENU_BOTTOM_ITEMS,
];
